module.exports = __webpack_public_path__ + "img/statistics_kfsl.1daa0271.png";